import { cn } from "@/lib/utils"
import type { MenuCategory } from "./types"
import { t } from "@/lib/i18n"

type CategoryChipsProps = {
  categories: MenuCategory[]
  activeId: number | "all"
  onChange: (id: number | "all") => void
}

export function CategoryChips({ categories, activeId, onChange }: CategoryChipsProps) {
  const chips: { id: number | "all"; label: string; emoji?: string | null }[] = [
    { id: "all", label: t("ui.react.features.user.category_chips.all") },
    ...categories.map((category) => ({
      id: category.id,
      label: category.name,
      emoji: category.emoji,
    })),
  ]

  return (
    <div
      className="flex gap-2 overflow-x-auto px-4 pb-1 scrollbar-none [&::-webkit-scrollbar]:hidden"
      data-testid="category-chips"
    >
      {chips.map((chip) => {
        const active = activeId === chip.id
        return (
          <button
            key={String(chip.id)}
            type="button"
            data-testid={`category-chip-${chip.id}`}
            data-active={active ? "true" : "false"}
            onClick={() => onChange(chip.id)}
            className={cn(
              "flex h-9 shrink-0 items-center gap-1.5 rounded-full border px-4 text-sm font-medium transition-colors",
              active
                ? "border-primary bg-primary text-primary-foreground"
                : "border-border bg-card text-foreground hover:bg-muted"
            )}
          >
            {chip.emoji && (
              <span className="text-[1.05rem] leading-none" aria-hidden="true">
                {chip.emoji}
              </span>
            )}
            {chip.label}
          </button>
        )
      })}
    </div>
  )
}
